<template>
  <div>
    <div
      class="drivers-user-respones-wrap"
      v-if="driversResponses
        && driversResponses.total_responses > 0"
    >
      <!-- <div class="response-card-wrap"
        v-for="(r, index) in driversResponses.response_list"
        :key="index"
      >
        <div class="response-title">
          {{r.interaction_question}}
        </div>
        <div class="response-body">
          {{r.formatted_response}}
        </div>
        <div class="response-footer">
          <v-chip
            class="mr-2"
            color="primary"
            outlined
          >
            {{r.interaction_sub_driver.replace(/([a-z0-9])([A-Z])/g, '$1 $2')}}
          </v-chip>
          <v-chip
            class="mr-2"
            color="primary"
            outlined
          >
            {{getSentiment(r.response_sentiment)}}
          </v-chip>
        </div>
      </div> -->
      <v-row class="ma-4">
        <v-col cols="3">
          <v-icon class="comment" style="font-size:35px">las la-comment</v-icon>
          <p class="headline mb-0">Comments</p>
          <small class="">See what your employees have to say about the
organization through this open-ended Q&A response repository. Amara

takes into account various employee sentiments before prompting them an
open-ended question.</small>
        </v-col>
        <v-col cols="9">
          <div class="d-flex justify-space-between">
            <strong>Highlighted comments({{driversResponses.total_responses}})</strong>
            <div @click="viewComments()" class="cursor-pointer">
              <strong>View all comments</strong>
              <span class="mt-n2"><v-icon color="primary">las la-external-link-alt</v-icon></span>
            </div>
          </div>
          <v-row class="pa-2">
            <v-col cols="12"  class="box-container overflow-hidden my-2 pa-2" v-for="(comment, c) in driversResponses.response_list" :key="c">
              <div class="pa-2">
                <v-row>
                  <v-col cols="1" class="py-0">
                    <div style="width:40px; height:40px; border:1px solid #ccc; border-radius:100%; position:relative; text-align:center;padding-top:8px;">
                      <span style="font-weight:bold; font-size:18px;" v-if="comment.parent_response_rating">{{comment.parent_response_rating}}</span>
                      <span style="font-weight:bold; font-size:14px;" v-if="comment.parent_response_rating">/5</span>
                      <span style="font-weight:bold; font-size:16px;" v-if="!comment.parent_response_rating">--</span>
                    </div>
                  </v-col>
                  <v-col cols="8" class="py-0">
                    <p class="mb-0" style="font-weight:bold; font-size:80%;">{{comment.interaction_parent_question}}</p>
                    <p class="mb-0 mt-1" style="font-weight:bold; color:grey; font-size:80%;">{{dayjs(comment.createdAt).format('DD-MM-YYYY')}} &#8226; <span v-if="comment.interaction_driver"> Driver : <v-chip small>{{comment.interaction_driver}}</v-chip> &#8226; </span> <span v-if="comment.interaction_sub_driver">Sub driver : <v-chip small>{{comment.interaction_sub_driver}}</v-chip> &#8226;</span>   <span style="cursor:pointer" @click="openEmployee(comment.user_profile_id)">{{comment.user_name}}</span> </p>
                  </v-col>
                  <v-col cols="3" class="py-0 d-flex justify-end">
                    <div style="font-size:12px;padding-right:2px" class="pt-1">
                      Response sentiment:
                    </div>
                    <div>
                      <v-chip style="float:right;" v-if="comment.response_sentiment < 0.5" color="rgba(244, 67, 54, 0.2)" class="" small>Negative</v-chip>
                      <v-chip style="float:right;" v-if="comment.response_sentiment == 0.5" color="rgba(246, 251, 252, 1)" class="" small>Neutral</v-chip>
                      <v-chip style="float:right;" v-if="comment.response_sentiment > 0.5" color="rgba(100, 231, 100, 0.2)" class="" small>Positive</v-chip>
                    </div>
                  </v-col>
                  <v-col cols="12" class="pb-0">
                    <v-row no-gutters>
                      <v-col cols="1"></v-col>
                      <v-col cols="11">
                        <p class="mb-0" style="">{{comment.formatted_response}}</p>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </div>
            </v-col>
          </v-row>
        </v-col>
        <v-row no-gutters class="mt-n4">
          <v-col cols="3"></v-col>
          <v-col cols="9">
            <div @click="viewComments()" class="cursor-pointer pl-3">
              <strong>View all comments</strong>
              <span><v-icon color="primary">las la-external-link-alt</v-icon></span>
            </div>
          </v-col>
        </v-row>
      </v-row>
      <!-- <v-row class="text-center">
        <div v-if="driversResponses.response_list < 1" class="box-container w-100 py-4 mt-4">
          <strong class="body-2 font-weight-bold grey--text">
            No comments available
          </strong>
        </div>
      </v-row> -->
    </div>
    <div v-if="driversResponses
      && driversResponses.total_responses === 0"
    >
      <div class="am-no-data box-container">
        No response has yet been received
      </div>
    </div>
  </div>
</template>

<script>
import DriversMixin from '../drivers-mixins';

export default {
  name: 'DriversUserResponses',

  mixins: [DriversMixin],

  data () {
    return {
      activeDriver: '',
      activeSubDriver: '',
      activeQuestion: '',
      updateReportFilters: {}
    };
  },

  watch: {
    $route: {
      immediate: true,
      deep: true,
      handler () {
        if (this.$router.currentRoute.params && this.$router.currentRoute.query.driver) {
          this.activeDriver = this.$router.currentRoute.query.driver;
        }
        if (this.$router.currentRoute.query && this.$router.currentRoute.query.subdriver) {
          this.activeSubDriver = this.$router.currentRoute.query.subdriver;
        }
        if (this.$router.currentRoute.query && this.$router.currentRoute.query.question) {
          this.activeQuestion = this.$router.currentRoute.query.question;
        }
        if (this.$route && this.$route.query && this.$route.query.filters) {
          this.updateReportFilters = JSON.parse(this.$route.query.filters);
        }
      }
    }
  },

  methods: {
    openEmployee (id) {
      this.$router.push(`/employees/view/${id}`).catch(() => {});
    },
    viewComments () {
      console.log(this.$route.query.filters);
      const queryParams = {};
      queryParams.filters = this.$route.query && this.$route.query.filters ? this.$route.query.filters : undefined;
      queryParams.driver = this.activeDriver || undefined;
      queryParams.subdriver = this.activeSubDriver || undefined;
      queryParams.question = this.activeQuestion || undefined;
      this.$router.push({
        path: '/comments',
        query: queryParams
      }).catch(() => {});
    },
    getSentiment (val) {
      // console.log('getSentiment -> val', val);
      if (val >= '0.1' && val <= '0.4') {
        // console.log('im in neg');
        return 'Negative';
      }
      if (val >= '0.6' && val <= '1.0') {
        // console.log('im in posis');
        return 'Positive';
      }
      if (val === '0.5') {
        // console.log('im in neutr');
        return 'Neutral';
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.drivers-user-respones-wrap {
  .response-card-wrap {
    background-color: var(--bg);
    border-radius: 8px;
    border: 1px solid rgba(0,0,0,0.1);
    box-shadow: 0 4px 20px 1px rgba(0, 0, 0, 0.06), 0 1px 4px rgba(0, 0, 0, 0.08) !important;
    margin: 8px 0;
    .response-title {
      padding: 16px;
      border-radius: 8px;
      background-color: #fbfcff;
      font-size: 16px;
      font-weight: 500;
      color: var(--primary-dark);
    }
    .response-body {
      padding: 16px;
      font-size: 14px;
    }
    .response-footer {
      padding: 16px;
      font-size: 14px;
    }
  }
}
.am-no-data {
  height: 15rem;
}
</style>
